import React, { useState } from "react";
import "./CommentFixed.css";
import { FiMoreHorizontal } from "react-icons/fi";
import me from "../../../../../assets/imgs/me.jpg";
import CommentItem from "./CommentItem/CommentItem";

export default function CommentFixed({
  item,
  modal,
  modalHideHandler,
  firstName,
}) {
  const [inputVal, setInputVal] = useState("");
  const [newItem, setNewItem] = useState(item.commetsArr);
  const textChangeHandler = (e) => {
    setInputVal(e.target.value);
  };

  const saveDescHandler = () => {
    setInputVal("");
    setNewItem([
      {
        userImg: me,
        commetsName: firstName,
        commetnsDesc: inputVal,
        commentsClub: 0,
      },
      ...newItem,
    ]);
  };
  return (
    <div>
      <div className={`comment-fixed ${modal ? "comment-fixed-show" : ""}`}>
        <h2>Response(24)</h2>

        <div className="text-area-div">
          <div className="text-img">
            <div className="shax-img">
              <img src={me} alt="" />
            </div>
            <p>{firstName}</p>
          </div>
          <textarea
            onChange={textChangeHandler}
            value={inputVal}
            name=""
            id=""
            cols="30"
            rows="10"
            placeholder="What are you looking.."
          ></textarea>
          <div className="icon-flex">
            <div className="bi">
              <p>B</p>
              <p>i</p>
            </div>

            <div className="can-flex">
              <button className="cancel">Cancel</button>
              {inputVal.length > 1 ? (
                <button className="response" onClick={saveDescHandler}>
                  Response
                </button>
              ) : (
                <button className="response">Response</button>
              )}
            </div>
          </div>
        </div>

        <h3 className="most">Most Relevant</h3>
        <hr />
        <ul className="des-ul">
          {newItem.map((element, i) => {
            return (
              <CommentItem
                key={i}
                firstName={firstName}
                inputVal={inputVal}
                element={element}
              />
            );
          })}
        </ul>
      </div>
      <div
        onClick={modalHideHandler}
        className={`modal-back1 ${modal ? "modal-back1-show" : ""}`}
      ></div>
    </div>
  );
}
